import { PkSimpleHeader } from '@uefadigital/panenka-react';

import RandomSponsors from '../RandomSponsors';

import type { PkTheme } from '@shared-types/common.types';

import '../../../../css/modules/common/sponsored-header.source.scss';

export const SimpleHeader = ({
  slot = '',
  title,
  handleCloseModal,
  competitionName,
  competitionUrl,
  sponsorName,
  theme = 'light',
  hideCompetitionLink = false,
}: {
  slot?: string;
  title?: string;
  handleCloseModal?: () => unknown;
  competitionName?: string;
  competitionUrl?: string;
  sponsorName?: string;
  theme?: PkTheme;
  hideCompetitionLink?: boolean;
}) => (
  <PkSimpleHeader
    slot={slot}
    text={title}
    className='simple-header js-simple-header'
    onPkClose={handleCloseModal}
    pk-theme={theme}
    titleColor='text-01'
  >
    {/* Logo */}
    {!hideCompetitionLink && (
      <a
        slot='competition-logo'
        className='simple-header__competition-logo pflazyload pflazy-bg'
        title={competitionName}
        href={`/${competitionUrl}`}
      >
        {competitionName}
      </a>
    )}

    {!!sponsorName && (
      <div slot='sponsor' className='simple-header__sponsor-wrap'>
        <div className='sponsors-slot'>
          <RandomSponsors sponsorName={sponsorName} position='header' creative='exclusive-section' />
        </div>
      </div>
    )}
  </PkSimpleHeader>
);
